import { useCallback } from 'react';
import { toError } from '@/library/utils/errors';
import useMountRef from './useMountRef';

const useCancelablePromise = () => {
  const isMounted = useMountRef();

  return useCallback(
    (promise, onCancel) =>
      promise
        ? new Promise((resolve, reject) => {
            promise
              .then(result => {
                if (isMounted()) {
                  resolve(result);
                }
              })
              .catch(error => {
                if (isMounted()) {
                  reject(toError(error, 'Cancelable promise rejected with non-Error value'));
                }
              })
              .finally(() => {
                if (!isMounted() && onCancel) {
                  onCancel();
                }
              });
          })
        : null,
    [isMounted]
  );
};

export default useCancelablePromise;
